import { Outlet, useLocation } from "react-router-dom";
import { DemoBanner } from "../demo/DemoBanner";
import { DemoAppNav } from "../demo/DemoAppNav";
import { DemoCtaFooter } from "../demo/DemoCta";
import { HintProvider } from "../demo/hints/HintProvider";
import { TourProvider } from "../demo/tour/TourProvider";
import { TourLauncher } from "../demo/tour/TourLauncher";
import { TourOverlay } from "../demo/tour/TourOverlay";
import { useLiveRoom } from "../demo/live/LiveRoom";
import LiveSession from "../demo/live/LiveSession";

/** Shared chrome for every demo route: the persistent sample-data banner, the real
 *  authed app nav (on workspace routes), the routed page, the CTA footer, the gold
 *  "Read more ?" hint state, and the guided-walkthrough launcher + spotlight overlay. */
export function DemoLayout() {
  // The front door (/) is the marketing entry; the live session is a full-screen
  // console with its OWN toolbar — both omit the global authed nav.
  const path = useLocation().pathname;
  const isEntry = path === "/";
  const isSession = path === "/session" || path.startsWith("/session/");
  const showNav = !isEntry && !isSession;
  // In a LIVE build, an active room mounts the co-drive chrome (fixed control bar +
  // video) over the normal routes, and pads content below the bar.
  // (LiveRoomProvider is always mounted — inert in the static build where room stays null.)
  const liveRoom = useLiveRoom().room;
  return (
    <HintProvider>
      <TourProvider>
        <div className={`flex min-h-dvh flex-col${liveRoom ? " pt-11" : ""}`}>
          <DemoBanner />
          {showNav && <DemoAppNav />}
          <div className="flex-1">
            <Outlet />
          </div>
          <DemoCtaFooter />
        </div>
        <TourLauncher />
        <TourOverlay />
        {liveRoom && <LiveSession />}
      </TourProvider>
    </HintProvider>
  );
}
